import React, { useEffect, useState } from "react";
import axios from "axios";
import {  useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { loginService } from "../../services/post-login";
import { getLogoutService } from "../../services/get-logout-service";
import { getUserInfoService } from "../../services/get-user-info-service";
import NetworkErrorScreen from "../NetworkError/NetworkError";



interface UserInfo {
  // Define the properties of the user info here
  username: string;
  email: string;
  password: string;
}

interface AuthContextValue {
  user: any;
  setUser: React.Dispatch<React.SetStateAction<UserInfo | undefined>>;
  setSearchQuery: React.Dispatch<React.SetStateAction<string | undefined>>;
  searchQuery: string;
  token: string | undefined;
  doLogin: (username: string, password: string) => Promise<void>;
  isAuthenticated: boolean;
  loading: boolean;
  getUserInfo: () => void;
  doLogout: () => Promise<void>;
  networkError : boolean,
  setNetworkError : any
}

export const UserContext = React.createContext<AuthContextValue>({
  user: undefined,
  setUser: () => {},
  setSearchQuery: (args: string): void => {},
  searchQuery: "",
  token: undefined,
  doLogin: async () => {},
  isAuthenticated: false,
  loading: true,
  getUserInfo: () => {},
  doLogout: async () => {},
  networkError : false,
  setNetworkError : (args: boolean) => {}
});

const Auth: React.FC<{ children: React.ReactNode }> = ({ children }) => {

  const [user, setUser] = useState<any>();
  const [searchQuery, setSearchQuery] = useState<any>();

  const [loading, setLoading] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState<string | undefined>();
  const [networkError , setNetworkError] = useState(false)
  const navigate = useNavigate();

  const doLogout = async () => {
    setLoading(true);

    getLogoutService()
      .then((response) => {
        if (response.status == 500) {
          console.log("server errror !");
          return;
        }
        if (response.success) {
          setIsAuthenticated(false);
          axios.defaults.headers.common = {};
          delete localStorage["token"];
          setUser(undefined);
          setToken(undefined);
          setLoading(false);
          navigate("/login");
        }
      })
      .catch((error) => {
        setLoading(false);

        console.log("error", error);
      });
  };

const getUserInfo = async () => {
  setLoading(true);
  setNetworkError(false);

  const tokenn = await localStorage.getItem("token");

  getUserInfoService(tokenn)
    .then((response) => {
      setLoading(false);
      setNetworkError(false);

      if (response.success) {
        setUser(response.content.user);
        setIsAuthenticated(true);
      } else {
        if (isAuthenticated) {
          toast.warning("session expired !");
          doLogout();
        }
      }
    })
    .catch((error) => {
      setLoading(false);

      // ✅ NETWORK ERROR DETECTION
      if (!error?.response) {
        setNetworkError(true);
      }

      console.log("getUserInfo error:", error);
    });
};


const doLogin = async (email: string, password: string) => {
  setLoading(true);
  setNetworkError(false);

  loginService({ email: email, password: password })
    .then((response) => {
      setLoading(false);
      setNetworkError(false);

      if (response.status == 500) {
        toast.error("Internal server error!");
        return;
      }

      if (!response.success) {
        toast.error(response?.message);
        return;
      }

      if (response.success) {
        setToken(response.content.token);
        setIsAuthenticated(true);
        toast.success("you logged In successfuly !");

        localStorage.setItem("token", response.content.token);
        getUserInfo();

        navigate("/acceuil");
      }
    })
    .catch((error) => {
      setLoading(false);

      if (!error?.response) {
        setNetworkError(true);
      }

      console.log("login error:", error);
    });
};


  useEffect(() => {
    getUserInfo();

    // Set up an interval to call getUserInfo every 10 minutes (600000 milliseconds)
    const intervalId = setInterval(() => {
      getUserInfo();
    }, 600000);

    // Clean up the interval when the component unmounts
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const contextValue: AuthContextValue = {
    user,
    setUser,
    setSearchQuery,
    searchQuery,
    token,
    doLogin,
    isAuthenticated,
    loading,
    getUserInfo,
    doLogout,
    networkError,
    setNetworkError
  };

if (loading) {
  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        backgroundColor: "#000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        color: "#d6ab76", // matching your logo gold tone
      }}
    >
      <img
        src="/logo192.jpg" // replace with your logo path
        alt="Mhiri Store Logo"
        style={{
          width: "100px",
          height: "100px",
          marginBottom: "20px",
          animation: "pulse 1.5s infinite ease-in-out",
        }}
      />
      <h2>Chargement...</h2>

      <style>{`
        @keyframes pulse {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.1); opacity: 0.7; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}</style>
    </div>
  );
}


if (networkError) {
  return (
    <NetworkErrorScreen
      onRetrySoft={() => {
        setNetworkError(false);
        getUserInfo();
      }}
      onReload={() => window.location.reload()}
    />
  );
}



  return (
    <UserContext.Provider value={contextValue}>
      {" "}
      {loading ? "..." : children}
    </UserContext.Provider>
  );
};

export default Auth;
